import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function ArticleDetailPage() {
  const [article, setArticle] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    axios.get(`${API_URL}/api/articles/${slug}`)
      .then(res => setArticle(res.data))
      .catch(err => {
        console.error("Error fetching article:", err);
        setArticle(null);
      });
  }, [slug]);

  if (!article) {
    return <div className="container">Laster inn artikkel...</div>;
  }

  const images = JSON.parse(article.image_urls || '[]');

  const ArticleContent = () => (
    <div className="article-text-content">
      <h1>{article.title}</h1>
      <p className="article-date">Publisert: {new Date(article.created_at).toLocaleDateString('nb-NO')}</p>
      <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.full_text) }} />
    </div>
  );

  const ImageGallery = () => (
    <div className={`article-gallery size-${article.gallery_size}`}>
      <Carousel 
        showThumbs={false} 
        showStatus={false} 
        infiniteLoop 
        useKeyboardArrows
        autoPlay
        interval={10000} // Bytter bilde hvert 10. sekund
        dynamicHeight={true}
      >
        {images.map((url, index) => (
          <div key={index}>
            <img src={url} alt={`${article.title} - bilde ${index + 1}`} />
          </div>
        ))}
      </Carousel>
    </div>
  );

  return (
    <div className={`article-detail-layout ${article.layout_option}`}>
      <Helmet>
        <title>{`${article.title} - Sunnfjord Naprapatsenter`}</title>
        <meta name="description" content={article.intro_text} />
      </Helmet>
      {(article.layout_option === 'images_before' || article.layout_option === 'images_left' || article.layout_option === 'images_right') && <ImageGallery />}
      <ArticleContent />
      {article.layout_option === 'images_after' && <ImageGallery />}
    </div>
  );
}

export default ArticleDetailPage;